/**
 * The public support mailbox.
 *
 * This is the ONLY contact mechanism the product exposes — there is no contact
 * route and no in-product dispute flow (Epic 6 is backlog). Several policy
 * pages instruct a user to "contact support", and on the damage-policy path
 * that instruction is load-bearing: a renter has 7 days after a return to raise
 * a condition problem before `processDisputeWindowExpiry` releases the payout,
 * after which the deposit is no longer ours to hold. An instruction with no
 * address attached let that window close on its own.
 *
 * Keep this in step with the address written into the policy copy itself; the
 * pairing is held by `tests/e2e/atdd-9-1-faq-and-policy-pages.spec.ts`, which
 * asserts both the literal text and a matching `mailto:` anchor in every
 * section that promises support contact.
 */
export const SUPPORT_EMAIL = 'support@muse-rent.com'
